export default __webpack_public_path__ + "static/media/loaderBlack.f079cd04.gif";